import { Text, Button, AlertBanner } from "snap-design-system";
import { AlertCircle, AlertTriangle, Building2, Check } from "lucide-react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

interface OrganizationChangeConfirmationProps {
  currentOrganization: string;
  newOrganization: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

interface OrganizationChangeConfirmationFooterProps {
  onConfirm?: () => void;
  onCancel?: () => void;
  isLoading?: boolean;
}

function OrganizationChangeConfirmation({
  currentOrganization,
  newOrganization,
}: OrganizationChangeConfirmationProps) {
  return (
    <div className="space-y-4">
      <AlertBanner
        variant="warning"
        icon={<AlertTriangle className="size-5" />}
        title="Atenção: Você está prestes a mudar de organização."
        message={
          <>
            <span className="block">Ao aceitar, você sairá da organização atual e ingressará na nova.</span>
            <span className="block mt-1">Od dados gerados na organização atual permanecerão salvos, mas ficarão inacessíveis.</span>
            <span className="block mt-1">Em seguida, sua sessão atual terminará e você será redirecionado à tela de login.</span>
          </>
        }
      />

      <div className="space-y-3">
        <div>
          <Text variant="body-sm" className="font-medium text-accent-500 pb-1">
            Organização atual:
          </Text>
          <Text variant="body-md" className="uppercase">
            {currentOrganization}
          </Text>
        </div>

        <div>
          <Text variant="body-sm" className="font-medium text-accent-500 pb-1">
            Nova organização:
          </Text>
          <Text variant="body-md" className="uppercase">
            {newOrganization}
          </Text>
        </div>
      </div>

      <Text weight={"semibold"}>
        Tem certeza de que deseja continuar?
      </Text>
    </div>
  );
}

function OrganizationChangeConfirmationFooter({ onConfirm, onCancel, isLoading }: OrganizationChangeConfirmationFooterProps) {
  return (
    <div className="flex gap-3 justify-end">
      <Button
        variant="ghost"
        onClick={onCancel}
      >
        Voltar
      </Button>
      <Button
        onClick={onConfirm}
        icon={isLoading ? <AiOutlineLoading3Quarters size={16} className="animate-spin" /> : <Check size={16} />}
        iconPosition="right"
        disabled={isLoading}
      >
        Confirmar Mudança
      </Button>
    </div>
  );
}

export const OrganizationChangeDialog = {
  Content: OrganizationChangeConfirmation,
  Footer: OrganizationChangeConfirmationFooter
};